import { useState, useEffect } from 'react';
import api from '../../services/api';
import Modal from '../UI/Modal';

export default function UserManager() {
    const [users, setUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState(null);
    const [form, setForm] = useState({ nom: '', email: '', plainPassword: '', roles: 'ROLE_USER' });
    const [agences, setAgences] = useState([]);

    useEffect(() => { loadUsers();loadAgences(); }, []);

    const loadUsers = async () => {
        try {
            const res = await api.get('/users');
            setUsers(res.data.member || []);
        } catch (err) {
            console.error(err);
        }
    };

    const loadAgences = async () => {
        try {
            const res = await api.get('/agences');
            setAgences(res.data.member || []);
        } catch (err) { console.error(err); }
    };

    const openCreate = () => {
        setSelected(null);
        setForm({ nom: '', email: '', plainPassword: '', agence: '', roles: 'ROLE_USER' });
        setShowModal(true);
    };

    const openEdit = (user) => {
        setSelected(user);
        setForm({
            nom: user.nom || '',
            email: user.email || '',
            plainPassword: '',
            agence: user.agence?.['@id'] || '',
            roles: user.roles?.includes('ROLE_SUPER_ADMIN') ? 'ROLE_SUPER_ADMIN'
                : user.roles?.includes('ROLE_ADMIN') ? 'ROLE_ADMIN'
                    : user.roles?.includes('ROLE_LOG') ? 'ROLE_LOG'
                        : user.roles?.includes('ROLE_SECRETAIRE') ? 'ROLE_SECRETAIRE'
                            : user.roles?.includes('ROLE_INF_DIET') ? 'ROLE_INF_DIET'
                                : user.roles?.includes('ROLE_NOT_USER') ? 'ROLE_NOT_USER'
                                    : 'ROLE_USER',
        });
        setShowModal(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (selected) {
                const payload = {
                    nom: form.nom,
                    email: form.email,
                    roles: [form.roles],
                    agence: form.agence || null,
                };
                if (form.plainPassword) {
                    payload.plainPassword = form.plainPassword;
                }
                const id = selected.id || selected['@id']?.split('/').pop();
                await api.patch(`/users/${id}`, payload, {
                    headers: { 'Content-Type': 'application/merge-patch+json' }
                });
            } else {
                await api.post('/users', {
                    nom: form.nom,
                    email: form.email,
                    plainPassword: form.plainPassword,
                    agence: form.agence || null,
                    roles: [form.roles],
                }, {
                    headers: { 'Content-Type': 'application/ld+json' }
                });
            }
            setShowModal(false);
            setSelected(null);
            setForm({ nom: '', email: '', plainPassword: '', roles: 'ROLE_USER' });
            loadUsers();
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h3 style={{ margin: 0 }}>Utilisateurs ({users.length})</h3>
                <button onClick={openCreate} style={addButtonStyle}>
                    + Ajouter un utilisateur
                </button>
            </div>

            <div style={{ backgroundColor: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 1px 6px rgba(0,0,0,0.07)' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                    <tr style={{backgroundColor: '#f8fafc'}}>
                        <th style={thStyle}>Nom</th>
                        <th style={thStyle}>Email</th>
                        <th style={thStyle}>Agence</th>
                        <th style={thStyle}>Rôle</th>
                        <th style={thStyle}>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {users.map(u => (
                        <tr key={u.id} style={{borderTop: '1px solid #f0f0f0'}}>
                            <td style={tdStyle}>{u.nom}</td>
                            <td style={tdStyle}>{u.email}</td>
                            <td style={tdStyle}>
                                {u.agence ? (
                                    <span style={{
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#4f46e5',
                                        backgroundColor: '#ede9fe',
                                        padding: '3px 10px',
                                        borderRadius: '20px'
                                    }}>{u.agence.nom}</span>
                                ) : '—'}
                            </td>
                            <td style={tdStyle}>
                                <span style={{
                                    padding: '3px 10px',
                                    borderRadius: '20px',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    backgroundColor: u.roles?.includes('ROLE_SUPER_ADMIN') ? '#fef3c7'
                                        : u.roles?.includes('ROLE_ADMIN') ? '#ede9fe'
                                            : u.roles?.includes('ROLE_LOG') ? '#dcfce7'
                                                : u.roles?.includes('ROLE_SECRETAIRE') ? '#dbeafe'
                                                    : u.roles?.includes('ROLE_INF_DIET') ? '#f0fdf4'
                                                        : u.roles?.includes('ROLE_NOT_USER') ? '#f1f5f9'
                                                            : '#f0f2f5',
                                    color: u.roles?.includes('ROLE_SUPER_ADMIN') ? '#d97706'
                                        : u.roles?.includes('ROLE_ADMIN') ? '#4f46e5'
                                            : u.roles?.includes('ROLE_LOG') ? '#16a34a'
                                                : u.roles?.includes('ROLE_SECRETAIRE') ? '#2563eb'
                                                    : u.roles?.includes('ROLE_INF_DIET') ? '#15803d'
                                                        : u.roles?.includes('ROLE_NOT_USER') ? '#64748b'
                                                            : '#666',
                                }}>
                                {u.roles?.includes('ROLE_SUPER_ADMIN') ? 'Super Admin'
                                    : u.roles?.includes('ROLE_ADMIN') ? 'Admin'
                                        : u.roles?.includes('ROLE_LOG') ? 'Logistique'
                                            : u.roles?.includes('ROLE_SECRETAIRE') ? 'Secrétaire'
                                                : u.roles?.includes('ROLE_INF_DIET') ? 'Inf / Diét'
                                                    : u.roles?.includes('ROLE_NOT_USER') ? 'Sans accès'
                                                        : 'Utilisateur'}
                                </span>
                            </td>
                            <td style={tdStyle}>
                                <button onClick={() => openEdit(u)} style={editButtonStyle} title="Modifier">
                                    <i className="ti ti-pencil"/>
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            {showModal && (
                <Modal title={selected ? 'Modifier l\'utilisateur' : 'Nouvel utilisateur'}
                       onClose={() => setShowModal(false)}>
                    <form onSubmit={handleSubmit}>
                        <div style={fieldStyle}>
                            <label style={labelStyle}>Nom *</label>
                            <input
                                type="text"
                                value={form.nom}
                                onChange={e => setForm({...form, nom: e.target.value})}
                                style={inputStyle}
                                required
                            />
                        </div>
                        <div style={fieldStyle}>
                            <label style={labelStyle}>Email *</label>
                            <input
                                type="email"
                                value={form.email}
                                onChange={e => setForm({...form, email: e.target.value})}
                                style={inputStyle}
                                required
                            />
                        </div>
                        <div style={fieldStyle}>
                            <label style={labelStyle}>Agence</label>
                            <select
                                value={form.agence}
                                onChange={e => setForm({...form, agence: e.target.value})}
                                style={inputStyle}
                            >
                                <option value="">— Aucune —</option>
                                {agences.map(a => (
                                    <option key={a['@id']} value={a['@id']}>{a.nom}</option>
                                ))}
                            </select>
                        </div>
                        <div style={fieldStyle}>
                            <label style={labelStyle}>
                                {selected ? 'Nouveau mot de passe (laisser vide pour ne pas changer)' : 'Mot de passe *'}
                            </label>
                            <input
                                type="password"
                                value={form.plainPassword}
                                onChange={e => setForm({...form, plainPassword: e.target.value})}
                                style={inputStyle}
                                required={!selected}
                            />
                        </div>
                        <div style={fieldStyle}>
                            <label style={labelStyle}>Rôle *</label>
                            <select value={form.roles} onChange={e => setForm({...form, roles: e.target.value})}
                                    style={inputStyle}>
                                <option value="ROLE_INF_DIET">Inf / Diét</option>
                                <option value="ROLE_SECRETAIRE">Secrétaire</option>
                                <option value="ROLE_LOG">Logistique</option>
                                <option value="ROLE_ADMIN">Administrateur</option>
                                <option value="ROLE_SUPER_ADMIN">Super Administrateur</option>
                                <option value="ROLE_NOT_USER">Sans accès</option>
                            </select>
                        </div>
                        <div style={{display: 'flex', gap: '12px', justifyContent: 'flex-end'}}>
                            <button type="button" onClick={() => setShowModal(false)} style={cancelButtonStyle}>
                                Annuler
                            </button>
                            <button type="submit" style={submitButtonStyle} disabled={loading}>
                                {loading ? 'Enregistrement...' : selected ? 'Modifier' : 'Créer'}
                            </button>
                        </div>
                    </form>
                </Modal>
            )}
        </div>
    );
}

const addButtonStyle = {
    padding: '8px 16px',
    backgroundColor: '#4f46e5',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600'
};
const editButtonStyle = {
    padding: '4px 8px',
    backgroundColor: '#f0f2f5',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer'
};
const thStyle = {padding: '12px 16px', textAlign: 'left', fontSize: '13px', fontWeight: '600', color: '#888' };
const tdStyle = { padding: '12px 16px', fontSize: '14px', color: '#333' };
const fieldStyle = { marginBottom: '16px' };
const labelStyle = { display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: '#444' };
const inputStyle = { width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' };
const cancelButtonStyle = { padding: '10px 20px', backgroundColor: '#f0f2f5', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' };
const submitButtonStyle = { padding: '10px 20px', backgroundColor: '#4f46e5', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' };